export class Machine {
    nom: string = "";
    numero_serie: string = "";
    type_machine_id: string = "";
    accessoire_machine_id: string = "";
    type_maintenance: string = "";
    etats_machines_id: string = "";
    condition_location: any = null;
    montant: any = null;
    image: any = null;
    localisation: any = null;
  
    private errorMessage: string;
  
    constructor() {
      this.errorMessage = "";
    }
  
    // Récupérer le message d'erreur
    getErrorMessage(): string {
      return this.errorMessage;
    }
  
    // Vérifier si on peut sauvegarder
    canSave(): boolean {
      // Vérification du nom
      if (!this.nom || this.nom.trim() === "") {
        this.errorMessage = "Veuillez saisir le nom de la machine";
        return false;
      }
  
      // Vérification du numéro de série
      if (!this.numero_serie || this.numero_serie.trim() === "") {
        this.errorMessage = "Veuillez saisir le numéro de série de la machine";
        return false;
      }
  
      // Vérification du type de machine
      if (!this.type_machine_id ) {
        this.errorMessage = "Veuillez sélectionner le type de machine";
        return false;
      }
  
      // Vérification des accessoires
      // if (!this.accessoire_machine_id ) {
      //   this.errorMessage = "Veuillez sélectionner au moins un accessoire";
      //   return false;
      // }
  
      // Vérification du type de maintenance
    //   if (!this.type_maintenance_id || this.type_maintenance_id.trim() === "") {
    //     this.errorMessage = "Veuillez sélectionner le type de maintenance.";
    //     return false;
    //   }
  
      // Vérification de l'état de la machine
      if (!this.etats_machines_id ) {
        this.errorMessage = "Veuillez sélectionner l'état de la machine";
        return false;
      }
  
      // Vérification de la condition de location
      if (!this.condition_location) {
        this.errorMessage = "Veuillez spécifier la condition de location";
        return false;
      }
  
      // Vérification du montant
      if (this.montant === null || isNaN(this.montant) || this.montant <= 0) {
        this.errorMessage = "Veuillez saisir un montant valide";
        return false;
      }
  
      // Vérification de l'image
      if (!this.image) {
        this.errorMessage = "Veuillez télécharger une image de la machine";
        return false;
      }
  
      // Si tous les champs sont valides
      this.errorMessage = ""; // Réinitialiser le message d'erreur
      return true;
    }
  }
  